export default __webpack_public_path__ + "static/media/no-teachers.af515e29.png";